import React from 'react'
import { Hero } from '@truphone/core-components'
import ConsumerSupportForm from '../components/contact/ContactSupportForm'

export default function ConsumerSupport(props) {
  const additionalAttributes =
    props.hero && props.hero.additionalAttributes ? JSON.parse(props.hero.additionalAttributes) : {}

  return (
    <>
      {props.hero && (
        <Hero
          {...props.hero}
          textColor={props.hero?.textStyle}
          ctas={props.hero.ctas?.map((x) => ({ ...x, style: 'text' }))}
          alignLeft={props.hero.layout === 'Left'}
          alignLeftLarge={props.hero.layout === 'LeftLarge'}
          borderBottom={additionalAttributes.borderBottom === 'true'}
          smallContainerWidth={additionalAttributes.smallContainerWidth === 'true'}
          smallPaddingBottomMobile={true}
          backgroundImage={props.hero.backgroundImage}
          backgroundImageMobile={props.hero.backgroundImageMobile || props.hero.backgroundImage}
        />
      )}

      <div className="bg-grey-100">
        <div className="container px-6 mx-auto text-center py-10 border-t border-grey-300 flex flex-wrap">
          {props.supportEmails && props.supportEmails.length > 0 && (
            <div className={`w-full lg:w-1/2 text-left lg:pr-10`}>
              {props.supportEmails &&
                props.supportEmails.map((email, i) => {
                  return (
                    <div key={`email-support-${i}`} className="mb-16">
                      {email.title && (
                        <p className="overline-text uppercase text-grey-700 mb-4">{email.title}</p>
                      )}
                      {email.text && <p className="text-base mb-4">{email.text}</p>}
                      {email.email && (
                        <p className="text-xl pl-4">
                          Email:{' '}
                          <a href={`mailto:${email.email}`} className="text-blue-100">
                            {email.email}
                          </a>
                        </p>
                      )}
                    </div>
                  )
                })}
            </div>
          )}

          <div
            className={`w-full mb-20 ${
              props.supportEmails?.length > 0 ? 'lg:w-1/2' : 'lg:w-2/3 mx-auto'
            }`}
          >
            <ConsumerSupportForm {...props.form} loadingText={props.loadingText} />
          </div>
        </div>
      </div>
    </>
  )
}
